const sanitizeFileName = (filename: string, charsLimit = 30) => {
  const nameWithouthExtension = filename.split('.', 1).pop();
  if (!nameWithouthExtension) return '';
  const name = nameWithouthExtension.slice(0, charsLimit);

  return nameWithouthExtension.length > charsLimit ? `${name}...` : name;
};

export { sanitizeFileName };
